import(/* webpackMode: "eager" */ "/home/buyme/htdocs/buyme.lk/src/app/error.tsx");
